
import CustomZoomControl from './CustomZoomControl';
import './Main.css';
import CreditModal from './CreditModal';
import Footer from './Footer'
import config from "../config.json";
import ReportPlay from './ReportPlay'
//import startPng from "../Images/start.png"
//import parkPng from "../Images/park.png"
//import endPng from "../Images/end.png"
import MarkerClusterGroup from 'react-leaflet-cluster'
import DrowArea from './DrowArea'
import DrowAreaUser from './DrowAreaUser'
import MarkerCustom from './MarkerCustom'
import CustomChatControl from './CustomChatControl'
import Chat from "./chat/Chat"
import {
  MapContainer, Marker, Popup, useMapEvents
} from 'react-leaflet'
import L from 'leaflet';
//import 'leaflet-wms-header';
import Count2 from './Count2';
import { Link, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';
import AddTileLayer from './AddTileLayer'
import CustomMyIconControl from './CustomMyIconControl'
import "leaflet.markercluster";
import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import { MainContext } from "../store/mainContext";
import Toasts from "./Toasts";
import { UserContext } from "../store/userContext";
import http from "../Services/httpService";
import noronServices from "../Services/noronServices";
import { toast } from "react-toastify";
//import { idText } from 'typescript';
import PanelMap from './PanelMap'

export default function Main() {
  let navigate = useNavigate();
  const timeUpdate = 1000 * 60 * 10;
  const [map, setMap] = useState(null);


  const [showCredit, setShowCredit] = useState(false);
  const { doRead, onMessage } = useContext(UserContext);
  const { changed, setDevices, defaultDevice, routePoint, updateLocation } = useContext(MainContext);

  const [isPosting, setIsPosting] = useState(false);
  const [listData, setListData] = useState([]);
  const [speed, setSpeed] = useState(500);
  const [form, setForm] = useState({ Lon: 1, Lat: 1 });
  const [showParking, setShowParking] = useState(true);

  useEffect(() => {
    if (!defaultDevice || !('longitude' in defaultDevice))
      return;
    if (map) {
      map.flyTo([defaultDevice.latitude, defaultDevice.longitude]);
    }
    // setZoom([15]);
  }, [defaultDevice]);

  useEffect(() => {
    LastLocationAllDeviceUser();
    //CheckVersion();
  }, [changed]);





  const DoMapData = (from, too) => {
    too.longitude = from.longitude;
    too.latitude = from.latitude;
    too.dtFa = from.dtFa;
    too.time = from.time;
    too.speed = from.speed;
    too.switch = from.switch;
    too.battery = from.battery;
    too.sequrity = from.sequrity;
    too.door = from.door;
    too.temp = from.temp;
    too.chargeSimCard = from.chargeSimCard;
    too.validLastLocation = from.validLastLocation;
    too.heading = from.heading;
    if ('shock' in from)
      too.shock = from.shock;
  }

  const [listPackes, setListPackets] = useState([]);

  const SavePath = (ime, packets) => {
    setListPackets(old => {
      let find = old.find(m => m.ime === ime);
      let index = old.indexOf(find);
      if (index == -1) {
        return ([...old, { ime: ime, packets: [packets] }])
      }
      old[index].packets = [packets, ...old[index].packets];
      return [...old];
    });
  }



  useEffect(() => {
    if (!map || !defaultDevice || !('longitude' in defaultDevice))
      return;
    let find = listPackes.find(m => m.ime === defaultDevice.ime);
    let index = listPackes.indexOf(find);
    if (index == -1) {
      return;
    }
    if (listPackes[index].packets.length < 2)
      return;
    //if (map && path && map.hasLayer(path))
    //  map.removeLayer(path);
    //setPath(createRouteAnimation({ points: listPackes[index].packets, paused: false, reverse: true }));
  }, [listPackes]);


  const [lastPacket, setLastPacket] = useState(null);
  const UpdateLocation = (ime, packets) => {
    setLastPacket({ ime: ime, packets: packets });
    SavePath(ime, packets);
    setListData(old => {
      let temp = old;
      let find = temp.find(m => m.ime === ime);
      let index = temp.indexOf(find);
      if (index == -1) {
        console.log('index', index)
        return [...old]
      }
      DoMapData(packets, temp[index]);
      temp[index].receiveNewLocation = Date.now();
      temp[index].dtFa = packets.dtFa + '*';
      //console.log('temp[index]', temp[index])
      return [...temp];
    });
  }


  useEffect(() => {
    if (!updateLocation)
      return
    UpdateLocation(updateLocation.ime, updateLocation.packets)
  }, [updateLocation]);



  const [fromPage, setFromPage] = useState(1);
  const [count, setCount] = useState(1);

  const LastLocationAllDeviceUser = async () => {
    setIsPosting(true);
    await noronServices.LastLocationAllDeviceUser2()
      .then(async ({ data }) => {
        setIsPosting(false);
        if (data.errorCode != 0) {
          toast.error(data.message, { theme: "colored" });
          setDevices([]);
          return
        }
        data.payload.list.map(x => {
          x.popup = false;
          x.dtFa = x.dtSpan <= (timeUpdate / 1000) ? x.dtFa + '*' : x.dtFa;
          return x;
        });
        setDevices(data.payload.list);
        setListData(data.payload.list);
        if (data.payload.list && data.payload.list.length > 0) {
          setCount(data.payload.list.length);
          if (map)
            map.flyTo([
              data.payload.list[0].latitude,//data.payload.list.length - 1
              data.payload.list[0].longitude//data.payload.list.length - 1
            ]);
          else
            setForm({
              Lon: data.payload.list[0].longitude,//data.payload.list.length - 1
              Lat: data.payload.list[0].latitude//data.payload.list.length - 1
            });
          if (data.payload.list && data.payload.list.length > 1)
            setFromPage(fromPage > 1 ? 2 : fromPage + 1);
        }
        //setShowMap(true);
      })
      .catch(err => {
        setIsPosting(false);
      });
  }
  useEffect(() => {
    if (map)
      map.flyTo([form.Lat, form.Lon]);
  }, [form]);

  const [play, setPlay] = useState("off");

  const onFinishCount = () => {
    setPlay(p => "show");
  }

  const playRoute = (e) => {
    e.preventDefault();
    setPlay(p => {
      const temp = p == "off" ? "play"
        : p == "play" ? "stop"
          : p == "stop" ? "play"
            : p == "show" ? "play"
              : "off";
      return temp;
    });
  }



  useEffect(() => {
    if (routePoint && routePoint.length > 0) {
      //if (play == "show") {
       // if (map && path && map.hasLayer(path))
       //   map.removeLayer(path);
       // setPath(createRouteAnimation({ points: routePoint, paused: true, reverse: false }));
      //}
      setPlay("show");
    } else
      setPlay("off");
  }, [routePoint]);


  const closeRoute = (e) => {
    e.preventDefault();
    //setMarkerArray([]);
    setPlay("off");
  }

  const [doOnPlay, setDoOnPlay] = useState(0)
  const onPlay = (c) => {
    setDoOnPlay(c);
  }


  const [clustering, setClustering] = useState(true);
  const MapPlaceholder = () => {
    return (
      <p>
        نمایش نقشه
        <noscript>You need to enable JavaScript to see this map.</noscript>
      </p>
    )
  }



  useEffect(() => {
    const timerInterval = setInterval(() => {
      let found = false;
      const list = listData.map(item => {
        if ('dtFa' in item && item.dtFa.indexOf("*") != -1) {
          item.dtFa = item.dtFa.replace("*", "");
          found = true;
        }
        return item;
      })
      if (found) {
        setListData(list);
      }
    }, timeUpdate);
    return () => clearInterval(timerInterval);
  }, [listData]);


  const [showDrowArea, setShowDrowArea] = useState(false);
  const [showPanelRight, setShowPanelRight] = useState(false);
  const [restart, setRestart] = useState(0)
  const backClick = (e) => {
    L.DomEvent.stopPropagation(e);
    e.preventDefault();
    e.stopPropagation();
    setShowPanelRight(p => {
      if (showDrowArea)
        setShowDrowArea(false);
      return !p
    });
    return false;
  }


  const showDrowAreaButtonClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setShowDrowArea(p => {
      if (showPanelRight)
        setShowPanelRight(false);
      return !p
    });

    return false;
  }
  const [pointsAreaUser, setPointsAreaUser] = useState([]);

  const MyComponent = () => {
    useMapEvents({
      click: (e) => {
        console.log('click map', e);
        setShowPanelRight(false);
        //setShowDrowArea(false);
        // L.DomEvent.stopPropagation(e);
        //e.preventDefault();
        //e.stopPropagation();

      },
      //locationfound:
      //mouseover: (e) => {
      //console.log('mouseover', e)
      //}
    });
    return (<></>)
  }

  useEffect(() => {
    console.log('map', map)
    if (map)
      map.invalidateSize();
  }, [map]);

  const [showBox, setShowBox] = useState(false)
  return (
    <>
      <CreditModal show={showCredit} handleClose={() => setShowCredit(false)} />
      {showDrowArea &&
        <DrowAreaUser
          doClose={e => {
            e.preventDefault();
            setShowDrowArea(false);
          }}
          points={pointsAreaUser}
          getPoints={(e) => {
            setPointsAreaUser(e)
          }} />
      }
      {play != "off" &&
        <ReportPlay
          doClose={closeRoute}
          play={play}
          onPlay={doOnPlay}
          onSetSpeed={setSpeed}
          onShowParking={setShowParking}
          doPlay={playRoute}
          doRestart={() => { setRestart(r => ++r) }}
        />}




      {listData.length > 10 &&
        <div className='row'>
          <div className='col'>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckChecked"
                checked={clustering}
                onChange={e => {
                  setClustering(!clustering)
                }}
              />
              <label
                className="form-check-label"
                htmlFor="flexSwitchCheckChecked">خوشه بندی</label>
            </div>
          </div>
        </div>
      }
      {/*listData.length != fromPage &&
        <div className="progress">
          <div className="progress-bar" role="progressbar" style={{ "width": fromPage / count * 100 + "%" }}
            aria-valuenow="100" aria-valuemin="0" aria-valuemax="100"></div>
        </div>
    */}
      <div className=' row'>
        {showPanelRight && <div className='col-auto pe-0'>
          <PanelMap newPacket={lastPacket} map={map} listData={listData} />
        </div>}
        <div className='col px-0'>
          <MapContainer
            center={[1, 1]}
            zoom={13}
            style={{
              //height: "100vh"
              zIndex: 99
            }}
            zoomControl={true}
            placeholder={<MapPlaceholder />}
            className="test"
            //whenCreated={(e)=>{console.log('ff',map)}}
            ref={setMap}
            id="map"
          >
            {isPosting &&
              <div className="position-absolute top-50 start-50 translate-middle bg-white shadow rounded p-3 d-flex flex-column align-items-center z-3">
                <div className="spinner-border text-success mb-2" role="status"></div>
                <small>در حال بارگذاری اطلاعات...</small>
              </div>
            }
            {/* <CustomZoomControl />*/}
            <CustomMyIconControl
              backClick={backClick}
              showDrowAreaButtonClick={showDrowAreaButtonClick} />
            <MyComponent />
            {/*
            <LayersControl.Overlay name="Marker with popup">
              {<MinimapControl position="topright" />}
            </LayersControl.Overlay>
	    */}
            <AddTileLayer />
            {play == "off" &&
              <CustomChatControl
                doOnClick={e => { setShowBox(p => !p) }} />
            }
            {showDrowArea &&
              <DrowArea
                editable={true}
                points={pointsAreaUser}
                getPoints={(e) => {
                  console.log('e2 point', e);
                  setPointsAreaUser(e)
                }}
              />
            }
            {play == "off" &&
              <>
                {listData.length > 10 && clustering &&
                  <MarkerClusterGroup chunkedLoading >
                    {listData.map((item, index) => (
                      <MarkerCustom
                        item={item}
                        showCredit={(e) => { setShowCredit(true) }}
                        defaultDevice={defaultDevice}
                        key={item.ime + "off" + index} />
                    ))}
                  </MarkerClusterGroup>
                }
                {(listData.length <= 10 || !clustering) &&
                  <>
                    {listData.map((item, index) => (
                      <MarkerCustom
                        item={item}
                        showCredit={(e) => { setShowCredit(true) }}
                        defaultDevice={defaultDevice}
                        key={item.ime + "off" + index} />
                    ))}
                  </>
                }
              </>
            }
            {/*
            {play != "off" && routePoint.map((item, index) => (
              <React.Fragment key={item.ime + "onreport" + index}>
                {index == 0 &&
                  <Marker key={"start1" + index}
                    position={[item.latitude, item.longitude]}
                    icon={new L.Icon({
                      iconUrl: startPng
                      , iconSize: [50, 50]
                      //.iconAnchor: [0, 44],
                      //popupAnchor: [12, -40],
                      //shadowUrl: null,
                      //shadowSize: null,
                      //shadowAnchor: null
                    })}              >
                    <Popup>
                      <div className="d-flex  "   >
                        <div className=" " >
                          {`${item.dtFa}  ${item.time}`}
                        </div>
                      </div>
                    </Popup>
                  </Marker>
                }

                {item.stopTime != "0" && showParking &&
                  <Marker key={"park2" + index}
                    position={[item.latitude, item.longitude]}
                    icon={new L.Icon({
                      iconUrl: parkPng
                      , iconSize: [50, 50]
                      //iconAnchor: [0, 44],
                      //popupAnchor: [12, -40],
                      //shadowUrl: null,
                      //shadowSize: null,
                      //shadowAnchor: null
                    })}              >
                    <Popup>
                      <div className="d-flex  "   >
                        <div className=" " >
                          {`${item.dtFa}  ${item.time}`}
                        </div>
                      </div>
                      
                    </Popup>
                  </Marker>
                }
              </React.Fragment>
            ))}
            {play != "off" && routePoint && routePoint.length >= 2 &&
              <Marker
                position={[routePoint[routePoint.length - 1].latitude, routePoint[routePoint.length - 1].longitude]}
                icon={new L.Icon({
                  iconUrl: endPng
                  , iconSize: [50, 50]

                  //iconAnchor: [0, 44],
                  //popupAnchor: [12, -40],
                  //shadowUrl: null,
                  //shadowSize: null,
                  //shadowAnchor: null
                })}            >
                <Popup  >
                  <div className="d-flex  "   >
                    <div className=" " >
                      {`${routePoint[routePoint.length - 1].dtFa}  ${routePoint[routePoint.length - 1].time}`}
                    </div>
                  </div>
                </Popup>
              </Marker>
            }
              */
            }
            <Count2
              speed={speed}
              list={routePoint}
              play={play}
              onFinish={onFinishCount}
              onPlay={onPlay}
              restart={restart}
              showParking={showParking}
            />


            {/*
              play != "off" &&
              routePoint.map((item, index) => {
                return index >= routePoint.length - 1 ?
                 <React.Fragment key={index + "a"}></React.Fragment> :
                  (<Circle 
                    center={[
                      [item.latitude, item.longitude], [routePoint[index + 1].latitude, routePoint[index + 1].longitude],
                    ]}
                    fillColor={item.distance>200?"red":"blue"}
                    radius={200} 
                    key={index + "b"}
                      />)
              }
            )*/}
            {/* ترسیم خط گزارش مسیر حرکت*/
            /*
              play != "off" &&
              routePoint.map((item, index) => {
                return index >= routePoint.length - 1 ? <React.Fragment key={index + "a"}></React.Fragment> :
                  <React.Fragment key={index + "a"}>
                    <Circle
                      center={[item.latitude, item.longitude]}
                      fillColor={item.distance > 200 ? "red" : "blue"}
                      radius={20}
                      key={index + "b"} />
                    <Polyline
                      positions={[
                        [item.latitude, item.longitude], [routePoint[index + 1].latitude, routePoint[index + 1].longitude],
                      ]} color={item.distance > 200 ? "red" : index % 2 == 0 ? "blue" : "green"}
                      onMouseOver={e => e.target.openPopup()}
                      onMouseOut={e => e.target.closePopup()}
                    >
                      <Popup>
                        <div className="d-flex  "   >
                          <div className=" " >
                            distance :{`${item.distance}`}
                          </div>
                        </div>
                        <div className="d-flex  "   >
                          <div className=" " >
                            {`${item.dtFa}  ${item.time}`}
                          </div>
                        </div>
                        <div className="d-flex  "   >
                          <div className=" " >
                            latitude :{`${item.latitude}   `}
                          </div>
                        </div>
                        <div className="d-flex  "   >
                          <div className=" " >
                            longitude :{`${item.longitude}   `}
                          </div>
                        </div>
                      </Popup>
                    </Polyline>
                  </React.Fragment>
              }
              )
              */}
          </MapContainer>
        </div>
      </div >
      <Toasts doRead={doRead} />
      {play == "off" && < Footer />}

      <Chat
        onCloseChatBox={e => { setShowBox(false) }}
        showBox={showBox}
        onMessage={onMessage} />

    </>
  );
}


